<template>
    <div class="progress-circle">
        <svg class="progress-svg" :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
            <!-- Círculo de fondo -->
            <circle class="progress-bg" :cx="size / 2" :cy="size / 2" :r="radius">
            </circle>
            <!-- Círculo de progreso -->
            <circle class="progress-bar" :cx="size / 2" :cy="size / 2" :r="radius"
                :style="{ strokeDasharray: circumference, strokeDashoffset: progressOffset }"></circle>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'CircularProgressBar',
    props: {
        size: {
            type: Number,
            default: 100, // Tamaño del círculo en px
        },
        progress: {
            type: Number,
            default: 0, // Progreso (0-100)
        },
        strokeWidth: {
            type: Number,
            default: 10, // Ancho del anillo
        },
    },
    data() {
        return {
            localProgress: 0
        }
    },
    computed: {
        radius() {
            // Radio del círculo (ajustado para el borde)
            return (this.size - this.strokeWidth * 2);
        },
        circumference() {
            // Circunferencia del círculo
            return 2 * Math.PI * this.radius;
        },
        progressOffset() {
            // Offset para el progreso
            return (-this.localProgress / 100) * this.circumference;
        },
    },
    watch: {
        progress: {
            immediate: true,
            handler(newProgress) {
                this.localProgress = newProgress || 0
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.progress-circle {
    position: relative;
    display: inline-block;

    .progress-svg {
        transform: rotate(90deg) scale(-1, 1);
    }

    .progress-bg {
        fill: none;
        stroke: #04C8C8;
        stroke-width: 20;
    }

    .progress-bar {
        fill: none;
        stroke: #F56C6C;
        /* Color del progreso (Bulma's primary color) */
        stroke-width: var(--stroke-width, 20);
        stroke-linecap: butt;
        transition: stroke-dashoffset 0.3s ease;
    }
}
</style>